import { render, staticRenderFns } from "./commonFlowSetting.vue?vue&type=template&id=4829fc82&scoped=true&"
import script from "./commonFlowSetting.vue?vue&type=script&lang=js&"
export * from "./commonFlowSetting.vue?vue&type=script&lang=js&"
import style0 from "./commonFlowSetting.vue?vue&type=style&index=0&id=4829fc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4829fc82",
  null
  
)

export default component.exports